import HomePage from "../../features/home/home-page";
import "../../styles/scss/demo3.scss";

export default function Home() {
  return <HomePage />;
}
